import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { ApiService, USER_ROLES } from 'src/app/core/services/api.service';

@Component({
  selector: 'app-talent-onboard-invitation',
  templateUrl: './talent-onboard-invitation.component.html',
  styleUrls: ['./talent-onboard-invitation.component.scss']
})
export class TalentOnboardInvitationComponent implements OnInit, OnDestroy {

  uniqueUserId: string | null = null;
  vacancyId: string | null = null;
  talent : any = null;
  email = new FormControl('', {
  nonNullable: true,
  validators: [
    Validators.required,
    Validators.email
  ]
});
formSubmitted = false;
  private destroy$ = new Subject<void>();
  inProgress: boolean = false;

  constructor(private router: Router,private apiService: ApiService) {
    }

  ngOnInit(): void {
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  talentSignup() {
    this.formSubmitted = true;
  if (this.email.invalid) {
    this.email.markAsTouched();
    return;
  }

  this.inProgress = true;

  this.apiService.createUser(this.email.value!, USER_ROLES.talent)
    .subscribe({
      next: () => {
        this.inProgress = false;
        this.router.navigate(['/'], {
          queryParams: { email: this.email.value }
        });
      },
      error: (err) => {
        console.error(err);
        this.inProgress = false;
      }
    });

  }

getErrorMessage(): string {
  // Show errors only after touch, typing, or submit
  if (!(this.email.touched || this.email.dirty || this.formSubmitted)) {
    return '';
  }

  if (this.email.hasError('required')) {
    return 'Email is required.';
  }
  if (this.email.hasError('email')) {
    return 'Please enter a valid email address.';
  }

  return '';
}


}

